import React from "react";
import MultipleDropdown from "./MultipleDropdown";
import SingleDropdown from "./SingleDropdown";

export interface DropdownValue {
  id: number | string;
  label: string | number;
}

function Dropdown({
  className,
  style,
  data,
  multipleValues,
  singleValue,
  setSingleValue,
  setMultipleValues,
  placeholder,
  title,
  name,
  isLoading,
  disabled,
  withVerticalSpacer,
  touched,
  error,
  withAddNewValue,
  setSearchValue,
}: {
  className?: string;
  style?: React.CSSProperties;
  data: DropdownValue[];
  multipleValues?: DropdownValue[];
  setMultipleValues?: (value: DropdownValue[]) => void;
  singleValue?: DropdownValue | null;
  setSingleValue?: (value: DropdownValue | null) => void;
  placeholder?: string;
  title?: string;
  name?: string;
  isLoading?: boolean;
  disabled?: boolean;
  withVerticalSpacer?: boolean;
  touched?: boolean;
  error?: string;
  withAddNewValue?: boolean;
  setSearchValue?: (value: string) => void;
}) {
  if (multipleValues !== undefined && setMultipleValues) {
    return (
      <MultipleDropdown
        data={data ?? []}
        multipleValues={multipleValues}
        setMultipleValues={setMultipleValues}
        className={className}
        style={style}
        placeholder={placeholder}
        title={title}
        name={name}
        isLoading={isLoading}
        disabled={disabled}
        touched={touched}
        error={error}
        withVerticalSpacer={withVerticalSpacer}
        withAddNewValue={withAddNewValue}
      />
    );
  }
  if (singleValue !== undefined && setSingleValue) {
    return (
      <SingleDropdown
        data={data ?? []}
        singleValue={singleValue}
        setSingleValue={setSingleValue}
        className={className}
        style={style}
        placeholder={placeholder}
        title={title}
        name={name}
        isLoading={isLoading}
        disabled={disabled}
        touched={touched}
        error={error}
        withVerticalSpacer={withVerticalSpacer}
        setSearchValue={setSearchValue}
      />
    );
  }
  return <></>;
}

export default Dropdown;
